import { contextFactory } from '@frontend/design-system';
import { UseWritebackSetupResults } from './useWritebackSetup';

export const [DigitalFormsWritebackSetupContext, useDigitalFormsWritebackSetupContext] =
  contextFactory<UseWritebackSetupResults>(
    'useDigitalFormsWritebackSetupContext must be used within a DigitalFormsWritebackSetupContext'
  );
